$(document).ready(function(){

	if($(".container__steps--current").length > 0 && $(".container__steps--current").text().indexOf("ステップ１") >= 0){
		step1_button_enable_disable_action();
		var agent_count = parseInt($("#new_contact_forms_step1 .container__inner__maker__agent-count").text().replace ( /[^\d.]/g, '' ));
		if(!isNaN(agent_count) && agent_count > 0 && $(".items-associate").length == 1){
			$('#new_contact_forms_step1 .container__inner__maker__agent-count').removeClass("hide-company-count");
		}
		if($("input[id^=contact_forms_step1_service_option_]").length > 0){
			count_agent_by_service_options();
			service_options_initial_checkbox_background_color_set_operation();
		}

		["customer_type", "choice_product_genre"].forEach(function(field_key){
			var field_name = "contact_forms_step1[" + field_key + "]";
			if($("input[name='" + field_name + "'][type='radio']:checked").length == 0) return;
			radio_button_background_color_change_operation(field_name);
		});

	}
	
	$("input[name='contact_forms_step1[choice_product_genre]']").on('click', function() {
		step1_button_enable_disable_action();
	});

	$("input[id^=contact_forms_step1_service_option_]").on("click", function() {
		count_agent_by_service_options();
		checkbox_background_color_change_operation(this.name);
	});

	$("input[name='contact_forms_step1[customer_type]']").on("click", function() {
		if($(".wrapper_service_option_product_conditions").length == 1) count_agent_by_service_options();
	});

	$(".step1-form__submit-button").on("click", function() { set_loading(".container"); });

});

window.set_loading = function (add_class) {
	if($(".loading-screen").length > 0) return;
	$(add_class).append("<div class='loading-screen'></div>");
	$('.loading-screen').append("<div class='loading-screen__spinner spinner-border' role='status'></div>");
	$('.loading-screen__spinner spinner-border').append("<span class='sr-only'></span>");
}

window.remove_loading = function (add_class) {
	$(".loading-screen").remove();
}

function step1_button_enable_disable_action() {

	if(is_all_required_field_inputted()){
		$("#new_contact_forms_step1 .button-disabled").attr("disabled", false).val("検索結果を見る >");
		$("#new_contact_forms_step1 .button-disabled").addClass("btn-info").removeAttr("data-disable-with");
	}else{
		$("#new_contact_forms_step1 .button-disabled").attr("disabled", true).val("必須項目を全て選択して下さい");
		$("#new_contact_forms_step1 .button-disabled").removeClass("btn-info");
	}

}

function is_all_required_field_inputted() {

	is_all_required_field_inputted_flag = true;
	if (!$("input[name='contact_forms_step1[customer_type]']").is(':checked')) is_all_required_field_inputted_flag = false;
	if (!$("input[name='contact_forms_step1[choice_product_genre]']").is(':checked')) is_all_required_field_inputted_flag = false;
	if ($(".items-associate").length < 1) is_all_required_field_inputted_flag = false;
	return is_all_required_field_inputted_flag;

}

function count_agent_by_service_options(){
	const url = "/form/step1/company_count_by_service_options";
	$.ajax({
		url,
		type: 'GET',
		data: {
			person_type: $("input[name='contact_forms_step1[customer_type]']:checked").val(),
			product_lot_ids: $('input[id^=contact_forms_step1_product_lot]').map(function(){ return $(this).val(); }).get(),
			service_option_ids: $("input[id^=contact_forms_step1_service_option_]:checked").map(function(){ return $(this).val(); }).get()
		}
	});
}
